import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { FlexContainer, TitleH5, HR } from 'heliocor-ui'
import 'styled-components/macro'

import { Carousel } from '../../../common/Carousel/Carousel'
import { ErrorList } from './ErrorList'
import { DetailsWrapper, DetailsParagraph } from './details.styles'
import { VideoViewer } from '../../../common/VideoViewer'
import { getFilteredProperties } from '../../../utils/documents'

function DocumentDetails({
    document,
    deleteDocument,
    sendForManualValidation,
    canDelete = true,
    owner
}) {
    const { t } = useTranslation()
    const maxRetries = useSelector(store => store.party.maxRetries)
    const docValidations = useSelector(store => store.party.docValidations)
    const partyType = useSelector(store => store.config.partyType)

    const isStructureEntity = owner && !(partyType === 'CONNECTED_PERSON' || partyType === 'CONNECTED_COMPANY')

    const documentType = document.type
    const documentRetriesReached = docValidations[documentType] > maxRetries
    
    const faceError = document.properties?.find(p => p.name === 'FACE' && p.value === 'false')
    const documentErrors = faceError ? ['ERROR_FACE'] : document.errors || []

    
    const documentSentForManualValidation = document.sentForManualValidation
    const documentData = isEmpty(document.properties) ? [] : getFilteredProperties(document)
    const documentImages = document.datas.map(doc => ({ src: doc.content, type: doc.fileType }))

    const validatedAutomatically = isEmpty(documentErrors) && !documentData.length ? ['VALIDATED_AUTOMATICALLY'] : []
    const messageList = [...documentErrors, ...validatedAutomatically]

    const errorsHidingDetails = ['NOT_VALIDATED', 'UNMATCHED_NAMES', 'UNMATCHED_FACES']
    const showDetails = !documentErrors.some(err => errorsHidingDetails.includes(err))

    return (
        <FlexContainer>
            <DetailsWrapper responsive>
                {documentType === 'VIDEO_SELFIE' 
                    ?   (<VideoViewer src={documentImages?.[0]?.src} />) 
                    :   (<Carousel images={documentImages || []} />)
                }
                <FlexContainer column alignItems='flex-end'>
                    <FlexContainer column margin='2rem 1rem' maxWidth='18rem' minWidth='18rem'>
                        <FlexContainer justifyContent='space-between' alignItems='baseline' >
                            <TitleH5 css='margin:.15rem;' value={t('documentDetails')} />
                        </FlexContainer>
                        <HR />
                        {showDetails && documentData.map((data, index) => (
                            <FlexContainer key={index}>
                                <FlexContainer alignItems='baseline'>
                                    <TitleH5
                                        css='margin:.1rem; width:8rem; font-weight:400;'
                                        value={t(Object.keys(data)[0])}
                                    />
                                    <DetailsParagraph value={Object.values(data)[0]} />
                                </FlexContainer>
                            </FlexContainer>
                        ))}
                        <ErrorList
                            errors={messageList}
                            documentType={documentType}
                            sendForManualValidation={sendForManualValidation}
                            sentForManualValidation={documentSentForManualValidation}
                            onRetryClicked={deleteDocument}
                            showRetry={isStructureEntity || (!documentRetriesReached && canDelete && maxRetries > 0)}
                        />
                    </FlexContainer>
                </FlexContainer>
            </DetailsWrapper>
        </FlexContainer>
    )
}

export { DocumentDetails }